import { render } from "./ProductSelect.vue?vue&type=template&id=68ca9f73&ts=true"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"

import "./ProductSelect.vue?vue&type=style&index=0&id=68ca9f73&lang=css"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__